
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'currentSection',
      'sections',
    ]),
  },
}



// WEBPACK FOOTER //
// ./components/mixins/Sections.vue